import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/AuthProvider';
import Login from './components/authentication/Login';
import DeveloperRoute from './routes/DeveloperRoute';
import AdminRoute from './routes/AdminRoute';
import AdminRoute2 from './routes/AdminRoute2';
import CreatorsSuiteApp from './components/admin/CreatorSuite';
import DeletePage from './components/delete/DeletePage';
import NoAccess from './components/authentication/NoAccess';
import SupportPage from './components/authentication/Support';
import PublicLinksPage from './components/public/PublicLinksPage';

// Import your other components/pages here

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Links Route - Outside AuthProvider to avoid auth context */}
        <Route path="/:conferenceId/:iconId" element={<PublicLinksPage />} />
        <Route path="/:conferenceId/:iconId/:itemId" element={<PublicLinksPage />} />        
        {/* All other routes wrapped in AuthProvider */}
        <Route path="/*" element={
          <AuthProvider>
            <Routes>
              {/* Login Route */}
              <Route path="/login" element={<Login />} />
              
              {/* Developer Control Panel Route */}
              <Route path="/cp/*" element={<DeveloperRoute />} />

              <Route path="/support" element={<SupportPage />} />

              <Route path="/noaccess" element={<NoAccess />} />

              <Route path="/deleteaccount" element={<DeletePage />} />

              {/* Admin Panel Route */}
              <Route path="/*" element={<AdminRoute />} />
              <Route path="/admin/*" element={<AdminRoute />} />
              
              {/* Add your other routes here */}
              {/* <Route path="/" element={<Home />} /> */}
              {/* <Route path="/account" element={<Account />} /> */}
              
              {/* Add a catch-all route for 404 if needed */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </AuthProvider>
        } />
      </Routes>
    </Router>
  );
};

export default App;